<template>
  <div>
    <div class="row justify-content-center">
      <div v-for="product in products" :key="product.id" class="col-10 col-sm-6 col-lg-4 col-xl-4">
        <CardProduct
          :product="product"
          :key="product.id"
          :isIntimo="isIntimo"
          @add-cart="addToCart($event)"
          @getProducts="$emit('getProducts')"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['products', 'isIntimo'],
  computed: {
    cart() {
      return this.$store.getters.cartProducts;
    }
  },
  methods: {
    addToCart(product) {
      if (this.cart.length) {
        const currencyIso = this.cart[0].currency.iso;
        if (currencyIso !== product.currency.iso) {
          alert('Sólo puedes comprar productos de una misma moneda');
        }
      }
      this.$store.dispatch('updateCartProducts', { ...product });
      this.$emit('getProducts');
    }
  },
  mounted() {
    this.$emit('isDeliveryProcess');
  }
};
</script>
